import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromInitiative from '../reducers/my-initiatives.reducer';

export const getMyInitiativeState = createSelector(
  fromFeature.getInitiativesState,
  (state: fromFeature.InitiativeState) => state.myInitiatives
);

export const getMyInitiativesEntities = createSelector(getMyInitiativeState, fromInitiative.getMyInitiativesEntities);

export const getAllMyInitiatives = createSelector(getMyInitiativesEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

export const getMyInitiativesLoaded = createSelector(getMyInitiativeState, fromInitiative.getMyInitiativesLoaded);
export const getMyInitiativesLoading = createSelector(getMyInitiativeState, fromInitiative.getMyInitiativesLoading);

export const getMyOrderedInitiatives = createSelector(getAllMyInitiatives, initiatives => {
  return initiatives.sort((a, b) => (a.title > b.title ? 1 : -1));
});
